<template>
  <div>
    <a-tooltip v-for="(status, index) in statusMap" :key="index">
      <template slot="title">
        {{ status.title }}
      </template>
      <i
        v-if="auction.status && status.id < statusMap[auction.status].id"
        class="text-success fe fe-check-circle"
      ></i>
      <i
        v-else-if="auction.status && status.id == statusMap[auction.status].id"
        class="text-primary fe fe-play-circle"
      ></i>
      <i v-else class="text-muted fe fe-circle"></i>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['auction'],
  computed: {},
  data() {
    return {
      statusMap: {
        created: {
          id: 1,
          title: 'Auction created',
        },
        announced: {
          id: 2,
          title: 'Auction announced',
        },
        live: {
          id: 3,
          title: 'Auction started',
        },
        closed: {
          id: 4,
          title: 'Auction closed',
        },
        completed: {
          id: 5,
          title: 'Auction completed',
        },
        canceled: {
          id: 6,
          title: 'Auction canceled',
        },
      },
    }
  },
  computed: {},
}
</script>

<style scoped>
i {
  font-size: 22px;
  margin-left: 10px;
}
</style>
